<template>
  <div>
    <div class="wrp">
      <div class="top-tit">Revenue Forecasting</div>
      <h1 class="clear">
        <span @click="linkTo('/revenue')">Revenue History</span>
        <span v-if="isRevenueTargetForecastActivated" class="active" @click="linkTo('current')" id="fore">Revenue
          Forecasting</span>
        <span @click="linkTo('/income')" v-if="doshiiFlag">Doshii Area</span>
        <!-- <button v-if="isPro" @click="openUpload">Import Excel</button> -->
        <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || squareFlag || oolioFlag) && isPro" @click="linkTo('/product-categories')">Product
          Categories</span>
        <span v-if="(oseriesFlag || squareFlag) && isPro" @click="linkTo('/terminals')">Terminals</span>
        <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || squareFlag || oolioFlag) && isPro" @click="linkTo('/revenue-group')">Revenue
          Group</span>
        <span v-if="!squareFlag && !swiftPosFlag" @click="linkTo('/accounting-categories')">Accounting Categories</span>

      </h1>

      <div v-if="isRevenueTargetForecastActivated" class="revenue">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item v-for="(month, i) in monthList" :key="i" :title="month" :name="month">
            <div class="revenue-more table-wrp">

              <el-table :data="tableDataYear[month]" border style="width: 100%">
                <el-table-column prop="cycle" label="Week Ending">
                </el-table-column>
                <el-table-column label="Mon">
                  <template slot-scope="scope">
                    <div :class="scope.row.monIsAvgCost === true ? 'red' : ''" :id="`mon-${scope.row.cycle}`">{{ scope.row.mon ? `$${scope.row.mon}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Tue">
                  <template slot-scope="scope">
                    <div :class="scope.row.tueIsAvgCost === true ? 'red' : ''" :id="`tue-${scope.row.cycle}`">{{ scope.row.tue ? `$${scope.row.tue}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Wed">
                  <template slot-scope="scope">
                    <div :class="scope.row.wedIsAvgCost === true ? 'red' : ''" :id="`wed-${scope.row.cycle}`">{{ scope.row.wed ? `$${scope.row.wed}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Thu">
                  <template slot-scope="scope">
                    <div :class="scope.row.thuIsAvgCost === true ? 'red' : ''" :id="`thu-${scope.row.cycle}`">{{ scope.row.thu ? `$${scope.row.thu}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Fri">
                  <template slot-scope="scope">
                    <div :class="scope.row.friIsAvgCost === true ? 'red' : ''" :id="`fri-${scope.row.cycle}`">{{ scope.row.fri ? `$${scope.row.fri}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Sat">
                  <template slot-scope="scope">
                    <div :class="scope.row.satIsAvgCost === true ? 'red' : ''" :id="`sat-${scope.row.cycle}`">{{ scope.row.sat ? `$${scope.row.sat}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Sun">
                  <template slot-scope="scope">
                    <div :class="scope.row.sunIsAvgCost === true ? 'red' : ''" :id="`sun-${scope.row.cycle}`">{{ scope.row.sun ? `$${scope.row.sun}` :
                      '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Total">
                  <template slot-scope="scope">
                    <div :id="`total-${scope.row.cycle}`">{{ scope.row.total ? `$${scope.row.total}` : '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Operating" width="100">
                  <template slot-scope="scope">
                    <!-- @click="operate(scope.row.id, scope.$index, scope.row)" -->
                    <div class="icon" :id="`action-${scope.row.cycle}`" @click="operate(scope.$index, scope.row)"></div>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div>No Data</div>
                </template>
              </el-table>

            </div>
          </el-collapse-item>

        </el-collapse>


      </div>


      <div v-if="isDoneLoad && !isRevenueTargetForecastActivated">
        <div class="error-container d-flex align-items-center justify-content-center">
          <card-unauthorized></card-unauthorized>
        </div>
      </div>

    </div>



    <el-dialog title="" :visible.sync="editTargetShow" :modal-append-to-body="false" :show-close="false"
      class="delEmployDio pad-rgt-0" :close-on-click-modal="false" width="1420px" center>
      <TreeTable title="Edit Revenue" :weekStart="weekStart" :currentWeek="currentWeek" :hasLabour="hasLabour"
        :list="tableData" :loading="loadingData"
        text="When encountering holidays, you can appropriately modify the forecasted Target Revenue so that Peiso can estimate it for you more reasonably."
        @cancel="editTargetShow = false" @confirm="confirmUpdate" :requesting="tableConfirming" />
    </el-dialog>

    <div style="display: none;">
      <TreeTable title="Edit Revenue" :weekStart="weekStart" :currentWeek="currentWeek" :hasLabour="hasLabour"
        :list="tableData" :loading="loadingData"
        text="When encountering holidays, you can appropriately modify the forecasted Target Revenue so that Peiso can estimate it for you more reasonably."
        @cancel="editTargetShow = false" @confirm="confirmUpdate" :requesting="tableConfirming" />
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import utils from '../../utils/utils';
import api from "../../api/dashboard";
import Api from "../../api/api";
import incomeApi from '../../api/income'
import treeTable from "../dashboard/component/treeTable.vue";
import revenueApi from '../../api/revenue';
import cardUnauthorized from '@/components/card/unauthorized';

export default {
  data() {
    return {
      isPro: false,
      hasLabour: true,
      doshiiFlag: false,
      activeName: '1',
      months: [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
      ],
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      tableData: [],
      tableDataYear: {},
      loadingData: false,
      hasLabour: false,
      weekStart: 1,
      currentWeek: [],
      editTargetShow: false,
      tableConfirming: false,
      currentYear: null,
      activeWeek: null,
      revenueForecaseList: [],
      isRevenueTargetForecastActivated: false,
      isDoneLoad: false,
      oseriesFlag: false,
      tevalisFlag: false,
      redcatFlag: false,
      squareFlag: false,
      swiftPosFlag: false,
      options: [],
    }
  },
  components: {
    TreeTable: treeTable,
    cardUnauthorized: cardUnauthorized
  },
  computed: {
    monthList() {

      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;

      // Create list of months for both current year and next year
      const monthList = this.months.map(month => `${month} ${currentYear}`);
      const nextYearMonthList = this.months.map(month => `${month} ${nextYear}`);

      // Combine both lists
      return [...monthList, ...nextYearMonthList];
    },
  },
  methods: {
    linkTo(path) {
      if (path === 'current') {
        this.reload()
      } else {
        this.$router.push(path)
      }
    },
    updateDataTableYear(weekDate, monthYearDate, data) {
      let totals = {
        mon: 0,
        tue: 0,
        wed: 0,
        thu: 0,
        fri: 0,
        sat: 0,
        sun: 0,
        total: 0,
      };

      data.map(item => {
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            const res = item[key];
            if (res && totals[key] >= 0) {
              totals[key] += res;
              totals['total'] += res;
            }
          }
        }
      });

      if (this.tableDataYear[monthYearDate] && this.tableDataYear[monthYearDate].length > 0) {
        const updateWeekData = this.tableDataYear[monthYearDate].map(item => {
          if (item.cycle == weekDate) {
            return {
              ...item,
              mon: utils.formatSplit(totals.mon),
              tue: utils.formatSplit(totals.tue),
              wed: utils.formatSplit(totals.wed),
              thu: utils.formatSplit(totals.thu),
              fri: utils.formatSplit(totals.fri),
              sat: utils.formatSplit(totals.sat),
              sun: utils.formatSplit(totals.sun),
              total: utils.formatSplit(totals.total),
            }
          } else {
            return item;
          }
        });

        return { ...this.tableDataYear, [monthYearDate]: updateWeekData }

      }

      return this.tableDataYear;

    },
    updateRevenue(data) {
      let formattedDate = new Date();


      // let revenueForecaseList = this.revenueForecaseList.map(res => ({
      //       revenue_stream: res.revenue_stream_id,
      //       week_ending_date: res.week_ending_date,
      //       year: res.year,
      //       month: res.month,
      //       mon: res.mon,
      //       tue: res.tue,
      //       wed: res.wed,
      //       thu: res.thu,
      //       fri: res.fri,
      //       sat: res.sat,
      //       sun: res.sun ,
      // }));

      const revenueData = data.map(item => {

        formattedDate = new Date(item.sunDateTime * 1000).toISOString().slice(0, 10);

        const date = formattedDate.split('-');

        // const exists = revenueForecaseList.find(res => (res.revenue_stream == item.incomeId && res.week_ending_date == formattedDate));

        const newData = {
          revenue_stream: item.incomeId,
          week_ending_date: formattedDate,
          year: date[0],
          month: date[1],
          mon: item.mon ? item.mon : 0,
          tue: item.tue ? item.tue : 0,
          wed: item.wed ? item.wed : 0,
          thu: item.thu ? item.thu : 0,
          fri: item.fri ? item.fri : 0,
          sat: item.sat ? item.sat : 0,
          sun: item.sun ? item.sun : 0,
        }

        // if (exists) {
        //   revenueForecaseList = revenueForecaseList.map(res => (res.revenue_stream == item.incomeId && res.week_ending_date == formattedDate) ? newData : res);
        // } else {
        //   revenueForecaseList.push(newData);
        // }

        return newData;

      })

      // revenueForecaseList
      revenueApi.saveTargetRevenueForecast({
        payload: { target_revenue_forecast: revenueData },
        callback: this.saveCallback
      })

      // UPDATE THE DATA TABLE WEEKLY
      const weekEndingDate = moment(formattedDate).format('DD-MMM-YYYY');
      const monthYearDate = moment(formattedDate).format('MMMM YYYY');
      this.tableDataYear = this.updateDataTableYear(weekEndingDate, monthYearDate, data);

      // Call weekly revenue endpoint when saving the data table
      const optionFind = this.options.find(item => this.convertTimestampToDate(item.sunDateTime) == revenueData[0].week_ending_date);

      if (optionFind) {
        api.weekProfitRevenueLabour({
          params: {
            dashBoardId: optionFind.dashBoardId,
            monDateTime: optionFind.monDateTime,
            sunDateTime: optionFind.sunDateTime
          },
          callback: (res) => {
            //console.log('response: ', res)
          }
        });
      }

    },
    confirmUpdate(data) {

      if (data && data.length > 0) {
        const revenueData = data[0];

        if (revenueData) {
          const date = new Date(revenueData.sunDateTime * 1000).toISOString().slice(0, 10);
          const currentDate = moment().format('YYYY-MM-DD');
          console.log('date: ', date, moment(date).isSameOrAfter(currentDate));
          if (moment(date).isSameOrAfter(currentDate)) {
            this.updateRevenue(data);
          } else {
            utils.alert2('', "You can't change or update the previous week revenue", 'error')
          }
        }
      }

    },
    saveCallback(res) {
      if (res.data.code == 0) {
        utils.alert2("", "Successfully saved revenue", "success");
        this.editTargetShow = false;
      } else {
        utils.alert2("", "There was an error during saving. Please contact the Peiso administrator.", "error");
      }
    },
    operate(index, row) {

      this.currentWeek = this.$box.loadWeekDatum(row.monDateTime)
      console.log('rows', row);
      this.tableData = [];

      let params = {
        incomeType: 1,
        monDateTime: row.monDateTime,
        sunDateTime: row.sunDateTime,
      };

      this.loadingData = true;
      this.activeWeek = moment(row.cycle, 'DD-MMM-YYYY').format('YYYY-MM-DD');
      api.getActualIncome({
        params: params,
        callback: this.targetIncomeCallback,
      });
    },

    async targetIncomeCallback(res) {
      this.loadingData = false;

      if (res.data.code == 0) {
        let data = res.data.data


        const result = await revenueApi.getTargetRevenueForecastWeek(this.activeWeek);
        const weekData = result.data.data;

        let totalOverAll = 0

        let tableDatum = [
          // { left: 'Forecast Revenue', mon: data.forecastRevenue.mon, tues: data.forecastRevenue.tue, wed: data.forecastRevenue.wed, thu: data.forecastRevenue.thu, fri: data.forecastRevenue.fri, sat: data.forecastRevenue.sat, sun: data.forecastRevenue.sun, shrink: false, color: '', total: foreCastSum },
          { left: 'Total', mon: 0, tues: 0, wed: 0, thu: 0, fri: 0, sat: 0, sun: 0, shrink: false, color: 'green', son: [], total: totalOverAll }
        ]

        if (result.data.code == 0 && weekData) {
          for (let i = 0; i < weekData.length; i++) {
            const item = weekData[i];
            totalOverAll += (item.mon + item.tue + item.wed + item.thu + item.fri + item.sat + item.sun);


            tableDatum[0].mon = item.mon;
            tableDatum[0].tues = item.tue;
            tableDatum[0].wed = item.wed;
            tableDatum[0].thu = item.thu;
            tableDatum[0].fri = item.fri;
            tableDatum[0].sat = item.sat;
            tableDatum[0].sun = item.sun;

          }
        }


        if (data.list && data.list.length > 0) {

          data.list.forEach((item) => {
            // expensesType == 1 it's only reveue
            if (item.expensesType == 1) {
              let temp = []

              if (item.actualIncomeList && item.actualIncomeList.length > 0) {
                item.actualIncomeList.forEach(i => {

                  i.mon = utils.checkValueExistsZero(0)
                  i.tue = utils.checkValueExistsZero(0)
                  i.wed = utils.checkValueExistsZero(0)
                  i.thu = utils.checkValueExistsZero(0)
                  i.fri = utils.checkValueExistsZero(0)
                  i.sat = utils.checkValueExistsZero(0)
                  i.sun = utils.checkValueExistsZero(0)

                  if (result.data.code == 0 && weekData) {
                    const exists = weekData.find(item => (item.revenue_stream_id == i.incomeId || item.revenue_stream == i.incomeId));

                    if (exists) {
                      i.mon = exists.mon
                      i.tue = exists.tue
                      i.wed = exists.wed
                      i.thu = exists.thu
                      i.fri = exists.fri
                      i.sat = exists.sat
                      i.sun = exists.sun
                    }
                  }


                  var totalIncome = i.mon + i.tue + i.wed + i.thu + i.fri + i.sat + i.sun
                  temp.push({ left: i.incomeName, mon: i.mon, tues: i.tue, wed: i.wed, thu: i.thu, fri: i.fri, sat: i.sat, sun: i.sun, editmon: false, edittues: false, editwed: false, editthu: false, editfri: false, editsat: false, editsun: false, withDollar: item.expensesType !== 3 ? true : false, color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''), monDateTime: i.monDateTime, sunDateTime: i.sunDateTime, revenueType: i.revenueType, incomeType: i.incomeType, id: i.id, incomeId: i.incomeId, expensesType: item.expensesType, incomeCommission: i.incomeCommission, ofDoshii: i.revenueFrom === 0 ? false : true, total: totalIncome })
                })
              }

              let totalExpenses = temp.reduce((total, value) => {
                return total + value.total
              }, 0)

              tableDatum[0].son.push({ left: item.expensesType === 1 ? 'Revenue' : (item.expensesType === 2 ? 'Delivery' : (item.expensesType === 3 ? 'Expenses' : (item.expensesType === 4 ? 'Labour' : ''))), mon: item.total.mon, tues: item.total.tue, wed: item.total.wed, thu: item.total.thu, fri: item.total.fri, sat: item.total.sat, sun: item.total.sun, shrink: false, color: item.expensesType !== 3 ? 'green' : 'pink', son: temp, expensesType: item.expensesType, total: totalExpenses })

            }

          })


          this.tableData = tableDatum;

          this.editTargetShow = true;

          console.log('tableData', this.tableData)

        } else {
          utils.alert2("", res.data.message, "error");
        }

      }


    },
    getActiveMonth() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      const activeMonth = `${this.months[currentMonth]} ${currentYear}`;

      return activeMonth;
    },
    getMonthWeekDays(monthYear) {
      const data = monthYear.split(' ');
      let month = 1;
      let year = data[1];

      const index = this.months.findIndex((element) => element === data[0]);

      if (index !== -1) {
        month = index + 1;
      }
      const result = this.generateMonthWeekList(year, month);
      let listWeekDays = [];

      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          const days = result[key];
          const monDate = days[0];
          const sunDate = days[days.length - 1]
          const monDateTime = Math.floor(new Date(monDate.date).getTime() / 1000);
          const sunDateTime = Math.floor(new Date(sunDate.date).getTime() / 1000);
          // utils.formatSplit(item.fri.cost)

          listWeekDays.push({
            cycle: key,
            fri: "0.00",
            friIsAvgCost: false,
            mon: "0.00",
            monIsAvgCost: false,
            sat: "0.00",
            satIsAvgCost: false,
            sun: "0.00",
            sunIsAvgCost: false,
            thu: "0.00",
            thuIsAvgCost: false,
            total: "0.00",
            tue: "0.00",
            tueIsAvgCost: false,
            wed: "0.00",
            wedIsAvgCost: false,
            monDateTime: monDateTime, // need to change
            sunDateTime: sunDateTime, //need to change
          });

        }
      }

      return listWeekDays;
    },
    generateMonthWeekList(year, month) {
      const result = {};
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);
      const weeks = [];

      let currentWeek = [];
      let currentDate = new Date(firstDay);
      let weekCount = 0;

      while (currentDate <= lastDay) {

        const day = currentDate.getDate();
        const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
        currentWeek.push({
          day: day,
          dayName: days[currentDate.getDay()],
          date: moment(currentDate).format('YYYY-MM-DD'),
          formated_date: moment(currentDate).format('MMM D'),
          cost: 0,
        });

        if (currentDate.getDay() === 0 || currentDate.getTime() === lastDay.getTime()) {

          const formated_key = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
          const key = moment(formated_key, 'D/M/YYYY').format('DD-MMM-YYYY');

          if (currentWeek.length == 7 || weekCount == 0) {

            if (weekCount == 0 && currentWeek.length !== 7) {

              const month = currentDate.getMonth();
              let year = currentDate.getFullYear();
              const numberOfDays = (7 - currentWeek.length);

              if (month == 0) {
                year = year - 1
              }

              const result = this.getLastNDaysOfPreviousMonth(month, year, numberOfDays);
              weeks.push({ key, days: [...result, ...currentWeek] });

            } else {

              weeks.push({ key, days: [...currentWeek] });

            }


            weekCount++
          }


          currentWeek = [];
        }

        currentDate.setDate(day + 1);
      }

      for (let i = 0; i < weeks.length; i++) {
        const week = weeks[i];
        // const monthKey = i === 0 ? `${month}/${year}` : `${month + 1}/${year}`;
        result[week.key] = week.days;
      }

      return result;
    },
    getLastNDaysOfPreviousMonth(month, year, n) {
      // Ensure month is between 1 and 12
      month = (month - 1 + 12) % 12 + 1;

      // Create a Date object for the first day of the current month
      const currentDate = new Date(year, month, 1);

      // Move to the last day of the previous month
      currentDate.setDate(0);

      // Get the last N days of the previous month
      const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      const result = [];
      for (let i = 0; i < n; i++) {
        result.unshift({
          day: currentDate.getDate(),
          dayName: days[currentDate.getDay()],
          date: moment(currentDate).format('YYYY-MM-DD'),
          formated_date: moment(currentDate).format('MMM D'),
          cost: 0,
        });
        currentDate.setDate(currentDate.getDate() - 1);
      }

      return result;
    },
    getTargetRevenueForecastCallback(res) {
      if (res.data.code == 0) {

        const list = res.data.data;
        this.revenueForecaseList = [...this.revenueForecaseList, ...list];
        // this.tableDataYear
        let tableDataWeekTotal = {};
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const key = moment(item.week_ending_date).format('DD-MMM-YYYY');
          let total = (item.mon + item.tue + item.wed + item.thu + item.fri + item.sat + item.sun);

          if (tableDataWeekTotal[key]) {
            tableDataWeekTotal[key].mon += item.mon;
            tableDataWeekTotal[key].tue += item.tue;
            tableDataWeekTotal[key].wed += item.wed;
            tableDataWeekTotal[key].thu += item.thu;
            tableDataWeekTotal[key].fri += item.fri;
            tableDataWeekTotal[key].sat += item.sat;
            tableDataWeekTotal[key].sun += item.sun;
            tableDataWeekTotal[key].total += total;
          } else {

            tableDataWeekTotal[key] = {
              mon: item.mon,
              tue: item.tue,
              wed: item.wed,
              thu: item.thu,
              fri: item.fri,
              sat: item.sat,
              sun: item.sun,
              total: total,

            }
          }

        }

        for (const key in tableDataWeekTotal) {
          if (Object.hasOwnProperty.call(tableDataWeekTotal, key)) {
            const monthYear = moment(key).format('MMMM YYYY');
            const result = tableDataWeekTotal[key];
            const updateTableYear = this.tableDataYear[monthYear].map(item => {
              if (item.cycle == key) {
                return {
                  ...item,
                  mon: utils.formatSplit(result.mon),
                  tue: utils.formatSplit(result.tue),
                  wed: utils.formatSplit(result.wed),
                  thu: utils.formatSplit(result.thu),
                  fri: utils.formatSplit(result.fri),
                  sat: utils.formatSplit(result.sat),
                  sun: utils.formatSplit(result.sun),
                  total: utils.formatSplit(result.total),
                }
              } else {
                return item;
              }
            })

            this.tableDataYear = { ...this.tableDataYear, [monthYear]: updateTableYear }

          }
        }

      }

    },
    convertTimestampToDate(timestamp) {
      // Convert the Unix timestamp to milliseconds by multiplying by 1000
      const date = new Date(timestamp * 1000);

      // Extract the year, month, and day
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');

      // Format into YYYY-MM-DD
      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate;
    }
  },
  mounted() {
    this.activeName = this.getActiveMonth();

    this.currentYear = new Date().getFullYear();
    const nextYear = this.currentYear + 1;

    revenueApi.getTargetRevenueForecastYear({
      payload: this.currentYear,
      callback: this.getTargetRevenueForecastCallback
    })

    revenueApi.getTargetRevenueForecastYear({
      payload: nextYear,
      callback: this.getTargetRevenueForecastCallback
    })

    for (let i = 0; i < this.monthList.length; i++) {
      const monthYear = this.monthList[i];
      this.tableDataYear[monthYear] = this.getMonthWeekDays(monthYear);
    }

    this.$root.$on('isPro', (isPro, others) => {
      this.isPro = isPro;
      this.isRevenueTargetForecastActivated = others.isRevenueTargetForecastActivated
      this.isDoneLoad = true
    })


    incomeApi.progress({
      callback: (res) => {

        if (res.data.code === 0 && res.data.data.doshiiFlag) {
          this.doshiiFlag = true
        }

        if (res.data.code === 0 && res.data.data.oseriesFlag) {
          this.oseriesFlag = true;
        }

        if (res.data.code === 0 && res.data.data.tevalisFlag) {
          this.tevalisFlag = true;
        }

        if (res.data.code === 0 && res.data.data.squareFlag) {
          this.squareFlag = true;
        }

        if (res.data.code === 0 && res.data.data.redcatFlag) {
          this.redcatFlag = true;
        }

        if (res.data.code === 0 && res.data.data.oolioFlag) {
          this.oolioFlag = true;
        }

        if (res.data.code === 0 && res.data.data.swiftPosFlag) {
          this.swiftPosFlag = true;
        }
      }
    })

    Api.getTimeList((res) => {
      if (res.data.code == 0 && res.data.data && res.data.data.list.length > 0) {
        this.options = res.data.data.list.filter(item => item.value == 'THIS WEEK' || item.value == 'NEXT WEEK');
      }
    });


  }

}
</script>

<style lang="scss">
.el-collapse-item__header {
  background-color: var(--background-color-3) !important;
  color: var(--text-color) !important;
  font-size: 15px !important;
  padding: 15px 20px;
  border: none !important;
}

.el-collapse-item__wrap {
  background-color: var(--background-color-3) !important;
  color: var(--text-color) !important;
  font-size: 15px !important;
  padding: 15px 20px;
  border: none !important;
}

.el-collapse {
  border: none !important;
}

.el-collapse-item {
  border-radius: 10px;
  margin-bottom: 5px;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.revenue {
  margin-bottom: 20px;
}

.wrp {
  width: 100%;

  .top-tit {
    font-size: 24px;
    color: var(--text-color);
    line-height: 28px;
    margin-bottom: 38px;
    font-weight: 600;
  }

  .red {
    color: #EA3796;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 39px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 27px;

    span {
      float: left;
      position: relative;
      cursor: pointer;
      color: #A6A7A9;
      margin-right: 36px;
    }

    .active {
      color: var(--text-color);

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 110%;
        height: 2px;
        background: #EA3796;
      }
    }

    button {
      float: right;
      display: block;
      outline: none;
      background: none;
      cursor: pointer;
      width: 280px;
      height: 60px;
      border: 2px solid #EA3796;
      color: #EA3796;
      margin: 0 auto;
      font-size: 26px;
    }
  }

  .table-wrp {
    margin-bottom: 30px;

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      mask-repeat: no-repeat !important;
      mask-size: 24px 24px !important;
      mask-position: center center !important;
      background-color: var(--text-color);
      mask: url('../../assets/pencil-square.svg');
      -webkit-mask: url('../../assets/pencil-square.svg');
      cursor: pointer;
    }
  }

  .btns {
    margin: 65px auto 0 auto;
    width: 610px;
  }

  button {
    width: 280px;
    height: 60px;
    outline: none;
    background: none;
    cursor: pointer;
    font-weight: 600;
  }

  .dark {
    border: 2px solid var(--text-color);
    color: var(--text-color);
    font-size: 26px;
    float: left;
  }

  .light {
    border: 2px solid #8E3771;
    color: #8E3771;
    font-size: 26px;
    float: right;
  }

  .usable {
    border: 2px solid #EA3796;
    color: #EA3796;
  }

  .pop-wrp {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background: var(--background-color-2);
    bottom: 0;
    right: 0;
    z-index: 102;

    .pop-confirm {
      width: 1250px;
      height: 280px;
      background: var(--background-color-4);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -140px 0 0 -625px;

      .triple {
        text-align: center;

        button {
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          box-sizing: border-box;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
        }

        button:nth-child(1),
        button:nth-child(2) {
          margin-right: 50px;
        }

        button:nth-child(1) {
          color: var(--text-color);
          border: 2px solid var(--text-color)FFF;
        }

        button:nth-child(3),
        button:nth-child(2) {
          color: #D13A90;
          border: 2px solid #D13A90;
        }
      }
    }

    h1 {
      font-size: 24px;
      line-height: 33px;
      font-weight: 600;
      margin-bottom: 50px;
      color: var(--text-color);
      text-align: center;
    }

    .btns {
      margin: 65px auto 0 auto;
      width: 610px;

      button {
        width: 280px;
        height: 60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
      }

      .dark {
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
      }

      .light {
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
      }

      .usable {
        border: 2px solid #EA3796;
        color: #EA3796;
      }
    }

    .normal {
      transform: rotate(0deg);
      opacity: 1;
      margin-left: -420px;
    }

    .second-step {
      width: 840px;
      height: 612px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -306px 0 0 -420px;
      box-sizing: border-box;
      padding: 65px 50px 0 50px;

      h2 {
        margin-bottom: 30px;
      }

      .upload-con {
        width: 100%;
        height: 280px;
        background: var(--background-color-2);
        box-sizing: border-box;
        border: 1px solid #5F5F5F;
        position: relative;
        text-align: center;

        .close {
          width: 20px;
          position: absolute;
          height: 20px;
          right: 28px;
          top: 69px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../assets/c.png');
          cursor: pointer;
        }

        .icon {
          display: block;
          width: 100%;
          height: 35px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
          background-image: url('../../assets/upload.png');
          margin-top: 80px;
          margin-bottom: 30px;
        }

        h3 {
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: var(--text-color);

          span {
            color: #D13A90;
          }
        }

        .upload-demo {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          bottom: 0;
        }

        .el-icon-loading {
          margin-top: 100px;
          font-size: 30px;
        }

        .file {
          width: 660px;
          height: 120px;
          background: var(--background-color-4);
          position: relative;
          margin: 80px auto 0 auto;
          display: flex;
          flex-direction: row;
          box-sizing: border-box;
          padding: 20px;

          .in {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            background-size: contain;
            background-image: url('../../assets/a.png');
            background-position: center center;
            background-repeat: no-repeat;
            flex: 0 0 auto;
          }

          .text {
            flex: 0 0 auto;
            text-align: left;
            width: 520px;

            .tit {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 24px;
              line-height: 33px;
              margin-bottom: 10px;
              margin-top: 5px;
            }

            .size {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }

    .upload-success {
      width: 410px;
      height: 349px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -176px 0 0 -210px;
      box-sizing: border-box;
      padding: 60px 50px 0 50px;

      i {
        display: block;
        width: 100%;
        height: 60px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        margin-bottom: 40px;
        background-image: url('../../assets/s.png');
      }

      h4 {
        font-size: 24px;
        line-height: 29px;
        margin-bottom: 50px;
        color: var(--text-color);
        text-align: center;
      }

      button {
        width: 100%;
      }
    }

    .lst {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        width: 100%;
        margin: 0;
        padding: 0;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
        color: var(--text-color);
        box-sizing: border-box;
        padding: 0 10px;
        text-align: center;
      }

      .box {
        width: 1250px;
        background: var(--background-color);
        box-sizing: border-box;
        padding: 65px 50px 65px 50px;

        .table-wrp {
          margin-bottom: 15px;
        }

        p {
          font-size: 18px;
          line-height: 25px;
          color: var(--text-color);
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/revenue/forcasting.vue